export enum SheetType {
  HelpSheet = 'AboutSheet',
  HomeSheet = 'HomeSheet',
  OtherSheet = 'OtherSheet',
}
